"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var getModelType = function getModelType(CBBType) {
  switch (CBBType) {
    case '$':
      return 'currency';

    default:
      return 'radio';
  }
};

var getShortCode = function getShortCode(code) {
  switch (code) {
    case 'Y':
      return true;

    case 'N':
      return false;

    default:
      return code;
  }
};
/**
 * Recursive function generating an object containing each question
 * @param {*} questions      : list of questions
 * @param {*} parentQuestion : parent question of the list of questions
 */


var generateQuestion = function generateQuestion(questions) {
  var parentQuestion = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
  return _objectSpread({}, questions.reduce(function (acc, q) {
    // Get the parent's answer having showChildren == true
    var showChildrenAnswer = parentQuestion === null || parentQuestion === void 0 ? void 0 : parentQuestion.possibleAnswers.find(function (a) {
      return a.showChildren;
    });
    var parentLinkCode = showChildrenAnswer ? {
      onlyFor: getShortCode(showChildrenAnswer.answerCode)
    } : {};
    return _objectSpread(_objectSpread({}, acc), (0, _defineProperty2.default)({}, q.questionId, {
      type: getModelType(q.type),
      labelKey: q.questionText,
      linkToParent: parentLinkCode,
      choices: q.possibleAnswers.map(function (a) {
        var code = a.answerCode;
        return {
          value: getShortCode(code),
          labelKey: a.answer
        };
      }),
      // Sub-questions
      questions: q !== null && q !== void 0 && q.childQuestions ? generateQuestion(q.childQuestions, q) : {}
    }));
  }, {}));
};
/**
 * 
 * @param {*} CBBQuestions questions that are specific to Dilawri provided by CBB via "tradeIn/questions" endpoint
 * @returns formatted model for displaying the question in the condition-report component
 */


var generateDilawriCBBFormModel = function generateDilawriCBBFormModel(CBBQuestions) {
  var formattedModel = {
    iconName: 'rapport',
    sections: {
      section1: {
        questions: generateQuestion(CBBQuestions)
      }
    }
  };
  return formattedModel;
};

var _default = generateDilawriCBBFormModel;
exports.default = _default;